
import React from "react";

interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

export const ProgressIndicator = ({ 
  currentStep = 1, 
  totalSteps = 5 
}: ProgressIndicatorProps) => {
  return (
    <div className="flex justify-center mb-12">
      <div className="flex items-center gap-3">
        {Array.from({ length: totalSteps }).map((_, index) => (
          <div
            key={index}
            className={`w-10 h-10 rounded-full flex items-center justify-center border-2 
              ${index + 1 === currentStep 
                ? "border-gebeya-pink bg-white text-gebeya-pink" 
                : "border-gray-200 text-gray-400"
              }`}
          >
            {index + 1}
          </div>
        ))}
      </div>
    </div>
  );
};
